function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "10.227",
  height: "16.735"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2383",
  "data-name": "Path 2383",
  d: "M14.508 14L8 20.512l1.859 1.859L18.227 14 9.859 5.636 8 7.5z",
  transform: "rotate(180 9.114 11.185)",
  fill: "#fff"
})));